const faqs = [
  {
    title:
      "What programming language is used for mobile application development?",
    description:
      "The most popular programming languages for mobile application development include Objective-C, Swift, Java, Kotlin, C#, Xamarin, React Native, Appcelerator, Cordova/PhoneGap, Ruby, Python, CSS, JavaScript, PHP, and BuildFire JS.",
  },
  {
    title: "What is the software development lifecycle?",
    description:
      "Software Development Life Cycle refers to applying standard business practices while building software applications. <br /> While these eight steps are the standard, some project managers may omit, split, or combine any of these as per the project requirements and scope.",
  },
  {
    title: "Is Microsoft Dynamics 365 available on-premise?",
    description:
      "Yes, Microsoft Dynamics 365 is available for an on-premises implementation. However, some features/functionalities might not be available in the on-premise version. <br /> Other than these, the enterprise application must have processes automation, a Bimodal IT approach, intuitive user experience, real-time analytics, cloud storage, centrally moderated data infrastructure, an event-driven approach, and smart customer support.",
  },

  {
    title: "What are the benefits of agile software development?",
    description:
      "Agile software development is a project management methodology that focuses on breaking the development process into numerous smaller builds. It then uses sprints or iterations in short development cycles to complete the project. This method of development allows iterative development, self-organizing teams, and better adaptation to change.",
  },
  {
    title: "What are the types of mobile applications?",
    description:
      "Mobile app developers build apps in one of these three categories: native apps, hybrid apps, and PWA (progressive web app). To develop these, numerous programming languages are used. Native apps are coded in a language that is supported by select mobile devices and operating systems. Hybrid apps are coded in a single language but they have the capacity to run on both Android and iOS platforms. A PWA (progressive web app) is an application that can be accessed from any web browser. It is lightweight and although it looks like a mobile app, it is not delivered natively on a specific device.",
  },
];

export default faqs;
